import TicketPanel from "./TicketPanel"

export default TicketPanel
